import { manageAPI } from "./index.js";

export const getCustomers = async (page, limit, searchQuery, global = false) => {
  const params = {
    page,
    limit
  };

  if (searchQuery) {
    params.search = searchQuery;
  }

  if (global) {
    params.global = true;
  }

  return (await manageAPI.get('crm/people', { params })).data;
}

export const getCustomerByEmail = async (email) => {
  return (await manageAPI.get(`crm/people/${email}`)).data;
}

export const getCustomerActivityHits = async (mauticId, page = 1, limit = 20) => {
  const params = { page, limit };
  return (await manageAPI.get(`crm/contacts/${mauticId}/activity/hits`, { params })).data;
}

export const getCustomerActivityEmails = async (mauticId, page = 1, limit = 20) => {
  const params = { page, limit };
  return (await manageAPI.get(`crm/contacts/${mauticId}/activity/emails`, { params })).data;
}

export const banCustomer = async (customerId, reason, global = false) => {
  return (await manageAPI.post(`customers/${customerId}/ban`, { reason, global })).data;
}

export const unbanCustomer = async (customerId) => {
  return (await manageAPI.post(`customers/${customerId}/unban`)).data;
}
